import {
    Api,
    domain,
    LocationSearchModeEnum,
    LocationSearchScopeEnum,
} from "@relode/core";

export const locationLookupService = {
    loadSuggestions: async (
        searchText: string,
        scope: LocationSearchScopeEnum,
        mode: LocationSearchModeEnum
    ): Promise<domain.Location[]> => {
        const url = "locations/suggest";
        const result = await Api.url(url)
            .retries(3)
            .useSignal()
            .throwOnAbort()
            .track({
                name:
                    "client.shared.services.locationLookupService.loadSuggestions",
                data: { searchText, scope, mode },
            })
            .post<domain.Location[]>({ searchText, scope, mode });

        return result;
    },

    getLocationByLocationId: async (locationId: number) => {
        const url = `locations/${locationId}`;
        const result = await Api.url(url)
            .retries(3)
            .useSignal()
            .throwOnAbort()
            .track({
                name:
                    "client.shared.services.locationLookupService.loadSuggestions",
            })
            .get<domain.Location>();

        return result;
    },
};
